import React from 'react';
import { FormattedMessage } from 'react-intl';

import { formatCurrency } from '../Utils';
import SquareChip, { type SquareChipProps } from '../SquareChip';

type CurrencySquareChipProps = {
	id: string;
	defaultMessage: string;
} & ({ value: number; values?: undefined } | { value?: undefined; values?: Record<string, any> }) &
	Pick<SquareChipProps, 'icon' | 'backgroundColor'>;

export default function CurrencySquareChip(props: CurrencySquareChipProps) {
	const values = props.values
		? Object.fromEntries(
				Object.entries(props.values).map(([key, value]) => [key, value ? formatCurrency(value) : 'N/A'])
			)
		: undefined;

	return (
		<SquareChip
			label={
				<FormattedMessage
					id={props.id}
					defaultMessage={props.defaultMessage}
					values={values || { value: props.value ? formatCurrency(props.value) : 'N/A' }}
				/>
			}
			disabled={!values && !props.value}
			icon={props.icon}
			backgroundColor={props.backgroundColor}
		/>
	);
}
